module.exports = __webpack_public_path__ + "img/temperature-three-quarters.745c6257.svg";